"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackAddVoucherClick = void 0;
const enums_1 = require("../enums");
const pushToDataLayer_1 = require("./pushToDataLayer");
function trackAddVoucherClick(clickText, clickElement, voucherValue) {
    const eventData = {
        eventName: enums_1.GA4EventName.ClickButton,
        feature_category: enums_1.GA4FeatureCategory.CustomerAccount,
        click_text: clickText,
        click_element: clickElement,
        voucher_value: voucherValue,
    };
    (0, pushToDataLayer_1.pushToDataLayer)({
        event: 'JS_Event',
        eventData,
    });
}
exports.trackAddVoucherClick = trackAddVoucherClick;
//# sourceMappingURL=trackAddVoucherClick.js.map